import React from 'react';
import { Link } from 'react-router-dom';

export default function TrainingService({ data }) {
    if (!data) return null;


    return (
        <section className="training-service">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-12 col-lg-6">
                        <div className="image-sec">
                            <img src={data?.image} alt="Training Service" className="img-responsive" />
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-6">
                        <div className="image-content">
                            <h3 className="heading heading-gap">{data?.title}</h3>
                            <p>{data?.description}</p>
                            <div className="btn-sec">
                                <Link className="default-btn" to={data?.link}>
                                    <span>{data?.buttonText}</span>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}